import requestFunctions from "../../functions/requestFunctions";


export const state = {
  COSTS_ITEMS_ITEM: {},
  COSTS_ITEMS_LIST: [],
  COSTS_ITEMS_TABLE_DATA: [],
  COSTS_ITEMS_ARRAY_DATA: [],
  COSTS_ITEMS_TOTAL_ROWS: 0
}

export const getters = {
  GET_COSTS_ITEMS_ITEM: (state) => {
    return state.COSTS_ITEMS_ITEM;
  },
  GET_COSTS_ITEMS_LIST: (state) => {
    return state.COSTS_ITEMS_LIST;
  },
  GET_COSTS_ITEMS_TABLE_DATA: (state) => {
    return state.COSTS_ITEMS_TABLE_DATA;
  },
  GET_COSTS_ITEMS_ARRAY_DATA: (state) => {
    return state.COSTS_ITEMS_ARRAY_DATA;
  },
  GET_COSTS_ITEMS_TOTAL_ROWS: (state) => {
    return state.COSTS_ITEMS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_COSTS_ITEMS_ITEM(state, item) {
    state.COSTS_ITEMS_ITEM = item;
  },

  UPDATE_COSTS_ITEMS_LIST(state, list) {
    
    state.COSTS_ITEMS_LIST = list.data;

    state.COSTS_ITEMS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.COSTS_ITEMS_TABLE_DATA = [];
    state.COSTS_ITEMS_ARRAY_DATA = [];

    list.forEach(el => {

      state.COSTS_ITEMS_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'name' : el.name,
        'comments'   : el.comments,        
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
      });

      state.COSTS_ITEMS_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name
      });
    });
  },
}

export const actions = {

  async FETCH_COSTS_ITEMS_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/costs/items/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COSTS_ITEMS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_COSTS_ITEMS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/costs/items';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_COSTS_ITEMS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_COSTS_ITEMS_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/costs/items';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_COSTS_ITEMS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/costs/items/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_COSTS_ITEMS_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/costs/items/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}